import React, { useEffect, useMemo, useState } from 'react';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import './service-action.scss';
import { useStores } from '../../../store';
import { Service } from '../../../../dtos/version.dto';
import { CrudConfig } from '../../../../model/table';
import { createServiceColumns } from '../../inventory/services/services-column-config';
import { EditorMode } from '../../../../utils/enums';
import useCustomModal from '../../../shared/custom-modal/custom-modal';
import usePromiseFeedback from '../../../shared/promise-feedback/usePromiseFeedback';
import serviceService from '../../../../services/service.service';
import { ServiceAndStatus } from '../../../../dtos/service-with-status.dto';
import { convertServiceAndStatusToCustomServiceType } from '../../../../utils/versionUtils';
import { DataEditorModal } from 'src/components/shared/edit-row-modal/edit-row-modal';

const RemoveServiceModalBody = () => <div className="modal-commit-message">Remove this custom service?</div>;

interface ServiceActionProps<Service> {
    item: ServiceAndStatus;
    crudConfig: CrudConfig<Service>;
    isCustom: boolean | undefined;
}

export const ServiceAction= ({ item, crudConfig, isCustom}: ServiceActionProps<Service>) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showModal, , contextHolder] = useCustomModal();
    const { fwVersionStore, ruleStore } = useStores();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();
    const [data, setData] = useState<Service[]>([]);

    useEffect(() => {
        const defaultServiceList = ruleStore.defaultServicesWithStatus;
        const defaultServices = defaultServiceList.map(_ => convertServiceAndStatusToCustomServiceType(_));
        const customService = ruleStore.customServices;

        setData([...customService, ...defaultServices]);
    }, [ruleStore.customServices, ruleStore.defaultServicesWithStatus]);

    const service= useMemo(() => {
        return convertServiceAndStatusToCustomServiceType(item);
    }, [item]);

    const serviceColumns = useMemo(() => createServiceColumns(ruleStore.specialServices), [ruleStore.specialServices]);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onRemove = (service: Service) => {
        showModal({
            wrapClassName: 'remove-row-modal-wrapper',
            width: 400,
            title: 'Remove',
            body: RemoveServiceModalBody,
            okText: 'Delete',
            cancelText: 'Cancel',
            onOk: () => promiseFeedbackFactory({
                promise: fwVersionStore.genericCrudMethod(serviceService.deleteCustomService, [service.displayName]),
                notifObj: { show: true }
            })
        });
    };

    const save = async (editedRowData: Service) => {
       await crudConfig?.updateCb?.(editedRowData, service);
    };

    return <>
        <span className="button-wrapper icon"><CustomIcon type={IconType.PENCIL} size={24}
                                                     onClick={() => setIsModalOpen(true)}/></span>
        <span className={`${isCustom ? 'vertical-separator' : ''}`}/>
        {isCustom && <button type="button" className="button-wrapper text" onClick={() => onRemove(service)}>Delete</button>}
        <DataEditorModal isOpen={isModalOpen}
            closeModal={closeModal}
            columnsConfig={serviceColumns}
            onSave={save}
            header={`Edit ${crudConfig?.entityName}`}
            okBtnText={'Save'}
            data={data}
            mode={EditorMode.EDIT}
            rowData={service}
            crudConfig={crudConfig} />
        {contextHolder}
        {promiseContextHolder}
    </>;
};